import { FC } from "react";
import { Stat } from "./types";

interface MembershipHeroDesktopProps {
  label: string;
  title: string;
  stats: Stat[];
  heroImage: string;
  isDark: boolean;
  bgClass: string;
  textClass: string;
}

const MembershipHeroDesktop: FC<MembershipHeroDesktopProps> = ({
  label,
  title,
  stats,
  heroImage,
  isDark,
  bgClass,
  textClass,
}) => {
  return (
    <div
      className={`${bgClass} rounded-0 flex w-full flex-col items-end gap-10 p-8 md:rounded-[26px] md:p-[60px] lg:flex-row lg:gap-[89px]`}
    >
      <div
        className={`flex w-full flex-col items-start justify-center gap-10 lg:w-[540px] lg:gap-[129px] ${textClass}`}
      >
        <div className="flex w-full flex-col gap-2.5">
          <span className="text-[18px] leading-[1.4] uppercase">{label}</span>
          <h2 className="text-[32px] leading-[1.2] font-normal whitespace-pre-wrap md:text-[44px]">
            {title}
          </h2>
        </div>
        <div className="flex w-full max-w-[511px] flex-col gap-8 md:flex-row lg:gap-[30px]">
          {stats.map((stat, i) => (
            <div key={i} className="flex w-auto flex-col gap-5">
              <span className="text-[24px] leading-[1.3] font-normal">
                {stat.value}
              </span>
              <span
                className={`text-[16px] leading-[1.5] ${isDark ? "text-white" : "text-gray-900"}`}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="relative mt-10 flex h-auto w-full items-center justify-center lg:mt-0 lg:h-[417px] lg:w-[472px]">
        <img
          src={heroImage}
          alt={label}
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
};

export default MembershipHeroDesktop;
